/** @format */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubmissionGuard } from 'src/app/models/submission-guard.model';

@Component({
  standalone: false,
  selector: 'app-guard-modal',
  templateUrl: './guard-modal.component.html',
  styleUrls: ['./guard-modal.component.css']
})
export class GuardModalComponent {
  @Input() guard!: SubmissionGuard;
  @Input() message: string = '';

  @Output() onProceed = new EventEmitter<void>();
  @Output() onGoBack = new EventEmitter<void>();

  isAcknowledged: boolean = false;

  get isAcknowledgedType(): boolean {
    return this.guard?.guardType === 'Acknowledged';
  }

  get proceedDisabled(): boolean {
    return this.isAcknowledgedType && !this.isAcknowledged;
  }

  proceed(): void {
    if (this.proceedDisabled) return;
    this.onProceed.emit();
  }

  goBack(): void {
    this.onGoBack.emit();
  }
}
